import React from 'react';
import { Box, Button, Stack, Tooltip, Typography, alpha } from '@mui/material';
const PHONE_PATH = 'M6.6 10.8a15.1 15.1 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.25 11.4 11.4 0 0 0 3.6.57 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.57a1 1 0 0 1-.25 1z';
const ERRORS = {
  mic: "Livy can't hear you. Allow the microphone for this site in your browser, then call again.",
  quota: "That's today's call time. It resets at midnight UTC.",
  connect: "The call didn't connect. Check your connection and try again.",
  off: "Calling Livy isn't on for this account yet.",
  readonly: 'Start a new chat to call.',
  unknown: "The call didn't connect. Check your connection and try again."
};
const STATES = {
  connecting: 'Connecting…',
  listening: 'Listening',
  checking: 'Checking the account…',
  speaking: 'Livy is talking'
};
export const clock = s => "".concat(Math.floor(s / 60), ":").concat(String(s % 60).padStart(2, '0'));
export const LivyCallButton = _ref => {
  let disabledReason = _ref.disabledReason,
    onCall = _ref.onCall;
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: disabledReason !== null && disabledReason !== void 0 ? disabledReason : ''
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Button, {
    size: "small",
    variant: "contained",
    onClick: onCall,
    disabled: !!disabledReason,
    startIcon: /*#__PURE__*/React.createElement("svg", {
      width: "14",
      height: "14",
      viewBox: "0 0 24 24",
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("path", {
      d: PHONE_PATH,
      fill: "currentColor"
    })),
    sx: {
      textTransform: 'none',
      fontSize: 12.5,
      borderRadius: 999,
      px: '12px',
      boxShadow: 'none'
    }
  }, "Call Livy")));
};
/** The call's status under the header. Nothing renders when no call has been made. */
export const LivyCallBar = _ref2 => {
  var _STATES$state;
  let state = _ref2.state,
    muted = _ref2.muted,
    seconds = _ref2.seconds,
    maxSeconds = _ref2.maxSeconds,
    error = _ref2.error,
    endedBy = _ref2.endedBy,
    onMute = _ref2.onMute,
    onEnd = _ref2.onEnd;
  if (state === 'idle') return null;
  const up = state === 'listening' || state === 'checking' || state === 'speaking';
  let text;
  if (state === 'error') text = ERRORS[error !== null && error !== void 0 ? error : 'unknown'];else if (state === 'ended') {
    text = endedBy === 'company' ? 'Call ended because the company changed.' : endedBy === 'limit' ? "Calls end after ".concat(Math.round(maxSeconds / 60), " minutes. Call again to keep going.") : "Call ended \xB7 ".concat(clock(seconds), ". The conversation is saved below.");
  } else text = muted && up ? 'Muted' : (_STATES$state = STATES[state]) !== null && _STATES$state !== void 0 ? _STATES$state : '';
  return /*#__PURE__*/React.createElement(Box, {
    sx: theme => ({
      px: '16px',
      py: '8px',
      borderBottom: 1,
      borderColor: 'divider',
      bgcolor: state === 'error' ? alpha(theme.palette.error.main, 0.08) : alpha(theme.palette.primary.main, 0.08)
    })
  }, /*#__PURE__*/React.createElement(Stack, {
    direction: "row",
    alignItems: "center",
    justifyContent: "space-between",
    sx: {
      flexWrap: 'wrap',
      gap: '8px'
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    direction: "row",
    alignItems: "center",
    spacing: "10px",
    sx: {
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    role: "status",
    "aria-live": "polite",
    sx: {
      fontSize: 13,
      fontWeight: 600
    }
  }, text), up && /*#__PURE__*/React.createElement(Typography, {
    sx: {
      fontSize: 12,
      color: 'text.secondary',
      fontVariantNumeric: 'tabular-nums'
    }
  }, clock(seconds), state === 'listening' && !muted ? ' · Talk any time. Livy can see this account.' : '')), up && /*#__PURE__*/React.createElement(Stack, {
    direction: "row",
    spacing: "8px"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "small",
    onClick: () => onMute(!muted),
    sx: {
      textTransform: 'none',
      fontSize: 12.5,
      minWidth: 0,
      px: '10px'
    }
  }, muted ? 'Unmute' : 'Mute'), /*#__PURE__*/React.createElement(Button, {
    size: "small",
    color: "error",
    variant: "outlined",
    onClick: onEnd,
    sx: {
      textTransform: 'none',
      fontSize: 12.5,
      borderRadius: 999,
      px: '12px'
    }
  }, "End call"))));
};